(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elite-collection-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target instanceof Element
      ? event.target.closest('.ukl-elite-collection__range .slider-nav__btn')
      : null;
    if (!button || button.disabled || !window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const carousel = button.closest('carousel-slider');
    if (!carousel || carousel.hasAttribute('inactive') || !carousel.slider
      || !Number.isFinite(carousel.slideSpan) || carousel.slideSpan <= 0
      || !Number.isFinite(carousel.slidesToScroll) || carousel.slidesToScroll <= 0) return;

    event.stopPropagation();
    const forwards = (button.name === 'next' && !carousel.rtl) || (button.name === 'prev' && carousel.rtl);
    carousel.slider.scrollBy({
      left: (forwards ? 1 : -1) * carousel.slideSpan * carousel.slidesToScroll,
      behavior: 'instant'
    });
  }, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (e.target.closest('a[href]')) return;

        const isDesktopMegaNav = this.matches('.js-mega-nav')
          && window.matchMedia(theme.mediaQueries.md).matches;

        if (isDesktopMegaNav) {
          e.preventDefault();
          return;
        }

        super.handleToggle(e);
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ukl-atelier-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ukl-light-lab')) {
    class UKLLightLab extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-light-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-light-panel]'));
        this.onClick = this.handleClick.bind(this);
        this.onKeydown = this.handleKeydown.bind(this);
        this.onBlockSelect = this.handleBlockSelect.bind(this);
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);
        this.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeydown);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      activate(index, moveFocus = false) {
        const targetIndex = (index + this.tabs.length) % this.tabs.length;
        this.tabs.forEach((tab, tabIndex) => {
          const isActive = tabIndex === targetIndex;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', String(isActive));
          tab.tabIndex = isActive ? 0 : -1;
        });
        this.panels.forEach((panel, panelIndex) => {
          const isActive = panelIndex === targetIndex;
          panel.hidden = !isActive;
          panel.classList.toggle('is-active', isActive);
        });
        if (moveFocus) this.tabs[targetIndex]?.focus();
      }

      handleClick(event) {
        const tab = event.target.closest('[data-light-tab]');
        if (!tab || !this.contains(tab)) return;
        this.activate(Number(tab.dataset.lightTab));
      }

      handleKeydown(event) {
        const tab = event.target.closest('[data-light-tab]');
        if (!tab || !this.contains(tab)) return;
        const index = Number(tab.dataset.lightTab);
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          event.preventDefault();
          this.activate(index + 1, true);
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          event.preventDefault();
          this.activate(index - 1, true);
        } else if (event.key === 'Home') {
          event.preventDefault();
          this.activate(0, true);
        } else if (event.key === 'End') {
          event.preventDefault();
          this.activate(this.tabs.length - 1, true);
        }
      }

      handleBlockSelect(event) {
        const panel = event.target.closest('[data-light-panel]');
        if (!panel || !this.contains(panel)) return;
        this.activate(Number(panel.dataset.lightPanel));
      }
    }
    customElements.define('ukl-light-lab', UKLLightLab);
  }

  if (!customElements.get('ukl-atelier-home')) {
    class UKLAtelierHome extends HTMLElement {
      connectedCallback() {
        const items = Array.from(this.querySelectorAll('[data-reveal]'));
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduceMotion || !('IntersectionObserver' in window)) {
          items.forEach((item) => item.classList.add('is-visible'));
          return;
        }
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            this.observer?.unobserve(entry.target);
          });
        }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
        items.forEach((item) => this.observer.observe(item));
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.observer = null;
      }
    }
    customElements.define('ukl-atelier-home', UKLAtelierHome);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ukl-retail-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ukl-hero-slider')) {
    class UKLHeroSlider extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-hero-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-hero-dot]'));
        this.status = this.querySelector('[data-hero-status]');
        this.activeIndex = 0;
        this.touchStartX = null;

        if (this.slides.length < 2) return;

        this.querySelector('[data-hero-previous]')?.addEventListener('click', () => this.show(this.activeIndex - 1));
        this.querySelector('[data-hero-next]')?.addEventListener('click', () => this.show(this.activeIndex + 1));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.heroDot))));
        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.show(this.activeIndex - 1);
          } else if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.show(this.activeIndex + 1);
          }
        });
        this.addEventListener('touchstart', (event) => {
          this.touchStartX = event.changedTouches[0]?.clientX ?? null;
        }, { passive: true });
        this.addEventListener('touchend', (event) => {
          if (this.touchStartX === null) return;
          const distance = (event.changedTouches[0]?.clientX ?? this.touchStartX) - this.touchStartX;
          this.touchStartX = null;
          if (Math.abs(distance) > 48) this.show(this.activeIndex + (distance < 0 ? 1 : -1));
        }, { passive: true });
      }

      show(requestedIndex) {
        const nextIndex = (requestedIndex + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, index) => {
          const isActive = index === nextIndex;
          slide.hidden = !isActive;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', String(!isActive));
        });
        this.dots.forEach((dot, index) => {
          const isActive = index === nextIndex;
          dot.classList.toggle('is-active', isActive);
          if (isActive) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        this.activeIndex = nextIndex;
        if (this.status) this.status.textContent = `Slide ${nextIndex + 1} of ${this.slides.length}`;
      }
    }
    customElements.define('ukl-hero-slider', UKLHeroSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
